import React from 'react';

import QRCode from 'qrcode.react';

import { bemCssModules } from '@utils';

import Logo from './logo.svg';

import styles from './QrCode.scss';

type QRCodeType = {
  className?: string;
  value: string;
  isHideLogo?: boolean;
};

const cn = bemCssModules(styles, 'QrCode');

const QrCode: CustomFC<QRCodeType> = ({ className, value, isHideLogo }) => (
  <div className={cn(null, [className])}>
    <QRCode
      value={value}
      className={cn('qrcode')}
      renderAs="svg"
      bgColor="var(--color-main-secondary-bg)"
      fgColor="var(--color-main-text)"
    />
    {!isHideLogo && <Logo className={cn('logo')} />}
  </div>
);

export default QrCode;
